import { SignalR } from "@/constant/constants";
import * as signalR from "@microsoft/signalr"

export class RealtimeHubService {

  getHubConnect() {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(import.meta.env.VITE_URL_API + SignalR.HUB)
      .withAutomaticReconnect()
      .build();
    return connection;
  }
}

export default RealtimeHubService